import classnames from 'classnames';

interface Props {
  id?: string;
  value: string;
  placeholder: string;
  type?: string;
  rows?: number;
  maxLength?: number;
  textClassName?: string;
  containerClassName?: string;
  containerStyle?: object;
  maxLengthContainerClassName?: string;
  disableLineBreak?: boolean;
  autoFocus?: boolean;
  onChange?: (text: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
}

export default function TextArea(props: Props) {
  const {
    id,
    value,
    placeholder,
    rows,
    maxLength,
    textClassName,
    containerClassName,
    maxLengthContainerClassName,
    containerStyle,
    disableLineBreak,
    autoFocus,
    onChange,
    onFocus,
    onBlur,
  } = props;

  function onKeyDown(e: any): void {
    if (e.keyCode === 13 && disableLineBreak) {
      e.preventDefault();
    }
  }

  function renderMaxLength() {
    return maxLength ? (
      <div className={classnames(maxLengthContainer, maxLengthContainerClassName)}>
        <p className={classnames('text-xs text-gray-100', { 'text-danger': value?.length >= maxLength })}>
          {value?.length ?? 0}/{maxLength}
        </p>
      </div>
    ) : null;
  }

  return (
    <div className={classnames(container, containerClassName)} style={containerStyle}>
      <textarea
        id={id}
        value={value ?? ''}
        defaultValue={value ?? ''}
        placeholder={placeholder}
        rows={rows ?? 3}
        onChange={(e) => onChange && onChange(e.target.value)}
        className={classnames('w-full placeholder:text-muted-foreground', textClassName)}
        maxLength={maxLength}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
        onFocus={() => onFocus && onFocus()}
        onBlur={() => onBlur && onBlur()}
      />
      {renderMaxLength()}
    </div>
  );
}

const container =
  'placeholder:font-normal text-brand-text-primary border border-brand-border rounded-lg p-xs items-center';

const maxLengthContainer = 'flex justify-end';
